/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dvcSearchType: NonNullable<unknown> }} Dvc_Search_Type_LabelInputs */

const en_dvc_search_type_label = /** @type {(inputs: Dvc_Search_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.dvcSearchType === "plate_current_owner") return /** @type {LocalizedString} */ (`Plate - current owner`);
	if (i?.dvcSearchType === "plate_owner_history") return /** @type {LocalizedString} */ (`Plate - owner history`);
	if (i?.dvcSearchType === "cpf_lookup") return /** @type {LocalizedString} */ (`CPF`);
	return /** @type {LocalizedString} */ (`${i?.dvcSearchType}`)
	
};

const pt_br2_dvc_search_type_label = /** @type {(inputs: Dvc_Search_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.dvcSearchType === "plate_current_owner") return /** @type {LocalizedString} */ (`Placa - atual proprietário`);
	if (i?.dvcSearchType === "plate_owner_history") return /** @type {LocalizedString} */ (`Placa - histórico de proprietários`);
	if (i?.dvcSearchType === "cpf_lookup") return /** @type {LocalizedString} */ (`CPF`);
	return /** @type {LocalizedString} */ (`${i?.dvcSearchType}`)
	
};

/**
* | dvcSearchType | output |
* | --- | --- |
* | "plate_current_owner" | "Plate - current owner" |
* | "plate_owner_history" | "Plate - owner history" |
* | "cpf_lookup" | "CPF" |
* | * | "{dvcSearchType}" |
*
* @param {Dvc_Search_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dvc_search_type_label = /** @type {((inputs: Dvc_Search_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dvc_Search_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dvc_search_type_label(inputs)
	return pt_br2_dvc_search_type_label(inputs)
});